import type { CSSProperties } from 'react'

import { cn } from '../../utils/cn'
import type { SidebarIcon } from './model'

const STAGGER_MS = 40

// A transition runs on its destination's timing, so only the collapse is staggered and springy.
const GLYPH =
  'absolute inset-0 size-4 transition-[scale,opacity] duration-150 ease-in motion-reduce:transition-none group-data-[collapsible=icon]:delay-(--swap-delay) group-data-[collapsible=icon]:duration-300 group-data-[collapsible=icon]:ease-[cubic-bezier(0.34,1.56,0.64,1)]'

interface SidebarRowIconProps {
  icon: SidebarIcon
  /** Takes over from icon on the collapsed rail, growing out of the glyph it replaces. */
  collapsedIcon?: SidebarIcon
  /** The row's place in its group; each row swaps a beat after the one above. */
  index: number
}

export function SidebarRowIcon({ icon: Icon, collapsedIcon: CollapsedIcon, index }: SidebarRowIconProps) {
  if (!CollapsedIcon) return <Icon aria-hidden="true" />

  return (
    <span
      className="relative size-4 shrink-0"
      style={{ '--swap-delay': `${index * STAGGER_MS}ms` } as CSSProperties}
    >
      <Icon
        aria-hidden="true"
        className={cn(
          GLYPH,
          'group-data-[collapsible=icon]:scale-250 group-data-[collapsible=icon]:opacity-0'
        )}
      />
      <CollapsedIcon
        aria-hidden="true"
        className={cn(
          GLYPH,
          'scale-25 opacity-0 group-data-[collapsible=icon]:scale-100 group-data-[collapsible=icon]:opacity-100'
        )}
      />
    </span>
  )
}
